import { useCallback, useState } from "react";
import { auth as api } from "@/lib/api/auth";
import { ApiError } from "@/lib/api/transport";
import { flushLearningEvents } from "@/lib/public-learning-visit";
import { useBotProtection } from "@/hooks/useBotProtection";

export type MarketingSignupResult = "success" | "email_taken" | "failed";

export function useMarketingSignup() {
  const [loading, setLoading] = useState(false);
  const { verify, challenge } = useBotProtection();

  const signup = useCallback(
    async (email: string, ref?: string) => {
      setLoading(true);
      try {
        const token = await verify("signup");
        await flushLearningEvents();
        await api.signup(email, ref, token);
        return "success" as const;
      } catch (error) {
        if (
          error instanceof ApiError &&
          typeof error.body === "object" &&
          error.body !== null &&
          "error" in error.body &&
          error.body.error === "email_taken"
        ) {
          return "email_taken" as const;
        }
        return "failed" as const;
      } finally {
        setLoading(false);
      }
    },
    [verify],
  );

  return { loading, signup, challenge };
}
